import { PreviewWorkStyleUI } from "features";

interface AssessmentWorkStyleProps {
  callback: (metric: string) => void;
}

const AssessmentWorkStyle: React.FC<AssessmentWorkStyleProps> = ({
  callback,
}) => {
  const submit = (data) => {
    const answered = parseInt(localStorage.getItem("answered") ?? "0");
    localStorage.setItem("answered", `${answered + 8}`);

    callback("work_style");
  };

  return (
    <>
      <PreviewWorkStyleUI submit={submit} />
    </>
  );
};

export { AssessmentWorkStyle };
